'use client';

import { createContext, FC, ReactNode, useCallback, useContext, useMemo, useState } from 'react';
import { firebaseAnalytics } from '@/hotdesk-ui/common-classes/firebase.service';
import LongTermBookingModal from './LongTermBookingModal';
import { LongTermQuoteTarget } from './longTermQuote.types';
type LongTermQuoteContextValue = {
  requestQuote: (target: LongTermQuoteTarget) => void;
};
const LongTermQuoteContext = createContext<LongTermQuoteContextValue | null>(null);
export const LongTermQuoteProvider: FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [target, setTarget] = useState<LongTermQuoteTarget | null>(null);
  const [open, setOpen] = useState(false);
  const requestQuote = useCallback((next: LongTermQuoteTarget) => {
    firebaseAnalytics('request_quote_clicked', {
      listing_id: next.listingId,
      workspace_id: next.workspaceId,
      source: 'long_term_offices'
    });
    setTarget({
      ...next,
      source: next.source || (next.listingId || next.workspaceId ? 'IWG' : 'banner')
    });
    setOpen(true);
  }, []);
  const value = useMemo(() => ({
    requestQuote
  }), [requestQuote]);
  return <LongTermQuoteContext.Provider value={value} data-sentry-element="unknown" data-sentry-component="LongTermQuoteProvider" data-sentry-source-file="LongTermQuoteContext.tsx">
            {children}
            <LongTermBookingModal show={open} target={target} onClose={() => {
      setOpen(false);
      setTarget(null);
    }} data-sentry-element="LongTermBookingModal" data-sentry-source-file="LongTermQuoteContext.tsx" />
        </LongTermQuoteContext.Provider>;
};
export const useLongTermQuote = (): LongTermQuoteContextValue | null => useContext(LongTermQuoteContext);